import ClinicList from './List';
import ClinicForm from './Form';
import ClinicImport from './Import';

export default {
    path: 'cadastros',
    redirect: '/cadastros/clinicas',
    name: 'Cadastro Clínicas',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'clinicas',
            name: 'list-clinic',
            component: ClinicList,
            meta: {
                requiresAuth: true,
                label: 'Listar Clínicas'
            }
        },
        {
            path: 'clinicas/novo',
            name: 'new-clinic',
            component: ClinicForm,
            meta: {
                requiresAuth: true,
                label: 'Adicionar Clínica'
            }
        },
        {
            path: 'clinicas/importar',
            name: 'import-clinic',
            component: ClinicImport,
            meta: {
                requiresAuth: true,
                label: 'Importar Clínica'
            }
        },
        {
            path: 'clinica/:id',
            name: 'edit-clinic',
            component: ClinicForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Clínica'
            }
        }

    ]
}



// WEBPACK FOOTER //
// ./src/views/clinic/router.js